import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import { Grid } from '../../theme/index';
import Item from '../Course/components/Item';

function FeaturedCoursesByIndustry({
  data: { industryPages = [], loading, error },
  industryName,
}) {
  if (error) return <h1>Error fetching courses!</h1>;

  if (loading)
    return (
      <div>
        <em>Loading...</em>
      </div>
    );

  let { courses = [], bundles = [] } =
    industryName === 'nursing'
      ? industryPages[0] || {}
      : industryPages[1] || {};
  courses = courses.map(course => {
    const { id, courseCard: { handle } = {} } = course;
    return {
      id,
      handle,
      type: 'course',
    };
  });

  bundles = bundles.map(bundle => {
    const { id, bundleCard: { handle } = {} } = bundle;
    return {
      id,
      handle,
      type: 'bundle',
    };
  });

  const featuredCourses = [...courses, ...bundles];
  return (
    <Grid>
      {featuredCourses &&
        featuredCourses.map((item, index) => {
          return (
            <Item
              key={index}
              name={'name'}
              link={item.id}
              img={`https://media.graphcms.com/${item.handle}`}
            />
          );
        })}
    </Grid>
  );
}

FeaturedCoursesByIndustry.defaultProps = {
  industryName: '',
};

export const featuredCourses = gql`
  query content($where: IndustryPageWhereInput) {
    industryPages(where: $where) {
      courses {
        id
        courseCard {
          handle
        }
      }
      bundles {
        id
        bundleCard {
          handle
        }
      }
      industry
    }
  }
`;

export default graphql(featuredCourses, {
  props: ({ data }) => ({
    data,
  }),
  options(props) {
    return {
      variables: {
        industry: props.industryName,
      },
    };
  },
})(FeaturedCoursesByIndustry);



// WEBPACK FOOTER //
// ./src/components/screens/Industry/FeaturedCoursesByIndustry.jsx